<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="550px"
      v-bind:body-style="{ height: '220px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <!-- <a-row>
          <a-form-model-item label="审核意见:" prop="reson">
            <a-radio-group v-model="searchList.type">
              <a-radio :value="1">
                同意
              </a-radio>
              <a-radio :value="2">
                拒绝
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-row> -->
        <a-row>
          <a-form-model-item label="备注:" prop="reson">
            <a-textarea :rows="4" v-model="searchList.reson" :allowClear="true" placeholder="请输入"/>
          </a-form-model-item>
        </a-row>
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    modalTitle: {
      type: String,
      default: () => "关闭",
    }, //标题
    type: {
      type: String,
      default: () => ""
    },//返回信息
  },
  data() {
    return {
      visible: true,

      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      //绑定值
      searchList: {
        reson: "",
      },

      //校验规则
      rules: {
        reson: [
          // {
          //   required: true,
          //   message: "审核驳回原因不能为空！",
          //   trigger: "blur",
          // },
          {
            max: 200,
            message: "不可超过200字",
            trigger: "blur",
          },
        ],
      },
    }
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("handleOk",this.searchList,this.type); 
        }
      });
    }

  },
}
</script>

<style scoped>
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
</style>
